import { actions } from 'src/constants';

const initialState = {
  data: [],
  hasLoaded: false,
  isLoading: false,
};

const actionMap = {
  [actions.HELP_GET_REQUEST]: (state) => ({
    ...state,
    hasLoaded: false,
    isLoading: true,
  }),

  [actions.HELP_GET_SUCCESS]: (state, { result }) => ({
    ...state,
    data: result.data,
    hasLoaded: true,
    isLoading: false,
  }),

  [actions.HELP_GET_FAILURE]: (state) => ({
    ...state,
    hasLoaded: false,
    isLoading: false,
  }),
};

export default (state = initialState, action) => {
  if (actionMap[action.type]) {
    return actionMap[action.type](state, action);
  }

  return state;
};
